import JourneyStepDisplay from 'Components/JourneyStepDisplay';

angular.module('upDirectives').directive('upJourneyStepDisplayRoot', [
	'$parse',
	function ($parse) {
		return {
			restrict: 'A',
			template: '<div></div>',
			replace: true,
			link: function ($scope, $element, $attr) {
				let firstElement = $element[0];
				var renderTimeout;
				var entity = null;
				var onSetJourneyStep = $parse($attr.onSetJourneyStep)($scope);

				var render = function () {
					if (renderTimeout) {
						clearTimeout(renderTimeout);
					}
					if (!entity) {
						return;
					}
					renderTimeout = setTimeout(function () {
						if (!firstElement) {
							return;
						}

						_getOrCreateRoot(firstElement).render(
							React.createElement(JourneyStepDisplay, {
								id: entity.id,
								disableActions: !entity.userEditable,
								journeyStep: entity.journeyStep,
								onSetJourneyStep: onSetJourneyStep,
								isSubaccount: (!$attr.type || $attr.type === 'client') && !!entity.operationalAccount,
								isInactive: !entity.active,
								type: $attr.type
							})
						);
					}, 20);
				};

				$scope.$on('$destroy', function () {
					_unmountRoot(firstElement);
					firstElement = undefined;
				});

				$scope.$watch($attr.upJourneyStepDisplayRoot, function (data) {
					entity = data;
					render();
				});

				render();
			}
		};
	}
]);
